import { z } from 'zod';
import { SubscriptionFinishedReason, SubscriptionKind, SubscriptionStatus } from '../../enums/Subscription';
import { CurrenciesIsoCodes } from '../../types/Currency';
import { BaseSchema } from '../BaseSchema';
import { CreditCardSchema } from '../CreditCard';
import { CustomerSchema } from '../Customer/Customer';
import { IuguFieldsSchema } from '../IuguFields';
import { StripeFieldsSchema } from '../StripeFields';
import { SubscriptionPlanSchema } from './SubscriptionPlan';
export var SubscriptionSchema = BaseSchema.extend({
    customer: z.union([z.string(), CustomerSchema]),
    customerId: z.union([z.string(), CustomerSchema]),
    autoRenew: z.boolean(),
    renewWithoutPayment: z.boolean(),
    cannotChangeAutoRenew: z.boolean(),
    cannotChangePlan: z.boolean(),
    finishedReason: z.nativeEnum(SubscriptionFinishedReason).optional(),
    kind: z.nativeEnum(SubscriptionKind),
    status: z.nativeEnum(SubscriptionStatus),
    iuguFields: IuguFieldsSchema,
    stripeFields: StripeFieldsSchema,
    currency: z.nativeEnum(CurrenciesIsoCodes)["default"](CurrenciesIsoCodes["BRL"]),
    creditCard: CreditCardSchema.optional().nullable(),
    creditCardId: z.string().optional().nullable(),
    plan: SubscriptionPlanSchema.deepPartial(),
    startDate: z.date(),
    endDate: z.date().optional(),
    error: z.string().optional()
});
